/** @module SiteAdmin/PDFRequestFileRenderer */
define([
    "dojo/_base/declare",
    "csi/heading/Url"
], function(declare,Url) {

    return declare(Url, {

        /**
         * Disable filtering
         * @param {Context} ctx
         * @param {Heading} h
         * @param {Spec} spec
         */
        getQuerySpec: function(ctx, h, spec) {
            return null;
        }

    });
});